import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { EyeOffSVG } from '../svg/eyeOff.svg';

const EyeOffIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <EyeOffSVG/>
    </div>
  );
};

export { EyeOffIcon };
